import { InjectionToken } from '@angular/core';
import { QuoteDataLayerStrategy } from './quote-data-layer.strategy';

export const QUOTE_DATA_LAYER_STRATEGIES = new InjectionToken<QuoteDataLayerStrategy[]>('QuoteDataLayerStrategies');
